export default __webpack_public_path__ + "static/media/rimber.cbf93321.jpg";